var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BrandTileCmp',{attrs:{"size":_vm.size,"image":_vm.image,"icon":_vm.tile.icon,"text":_vm.tile.text,"background":_vm.tile.background,"color":_vm.tile.color}})}
var staticRenderFns = []

export { render, staticRenderFns }